/**
 * NetworkCapture — Sikertelen API hívások rögzítése.
 * A fetch API-t monkey-patch-eli (az rPI ERP fetch-alapú ApiClient-et használ, nem Axios-t).
 * Ring buffer, max 50 entry.
 */

export interface FailedApiEntry {
  url: string;
  method: string;
  status: number;
  message?: string;
  timestamp: number;
}

const MAX_ENTRIES = 50;

class NetworkCaptureService {
  private entries: FailedApiEntry[] = [];
  private initialized = false;

  init(): void {
    if (this.initialized) return;
    this.initialized = true;

    const origFetch = window.fetch.bind(window);

    window.fetch = async (
      input: Parameters<typeof fetch>[0],
      init?: Parameters<typeof fetch>[1]
    ): Promise<Response> => {
      const response = await origFetch(input, init);

      // Csak 4xx/5xx hibákat rögzítjük, és csak /api/ hívásokat
      if (response.status >= 400) {
        const url =
          typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
        if (url.includes('/api/')) {
          this.push({
            url: url.replace(window.location.origin, ''),
            method: (init?.method || 'GET').toUpperCase(),
            status: response.status,
            timestamp: Date.now(),
          });
        }
      }

      return response;
    };
  }

  private push(entry: FailedApiEntry): void {
    this.entries.push(entry);
    if (this.entries.length > MAX_ENTRIES) {
      this.entries.shift();
    }
  }

  /** Utolsó N entry (ticket csatoláshoz) */
  getRecent(limit = 10): FailedApiEntry[] {
    return this.entries.slice(-limit);
  }

  getCount(): number {
    return this.entries.length;
  }

  clear(): void {
    this.entries = [];
  }
}

export const networkCapture = new NetworkCaptureService();
